<template>
  <b-row class="space" :align-h="right?'start':'end'">
    <b-row class="container-note" align-h="between" align-v="center">
      <div v-if="right" class="col-md-1">
        <b-avatar v-if="image" variant="info" :src="image"></b-avatar>
        <b-avatar
          v-else
          variant="primary"
          :class="{ right: right }"
          text="BV"
        ></b-avatar>
      </div>
      <div class="message-info col-md-11">
        <h4>{{ contact }}</h4>
        <span v-html="text"></span>
        <span>{{ time }}</span>
      </div>
      <div v-if="!right" class="col-md-1">
        <b-avatar v-if="image" variant="info" :src="image"></b-avatar>
        <b-avatar
          v-else
          variant="primary"
          :class="{ right: right }"
          text="BV"
        ></b-avatar>
      </div>
    </b-row>
  </b-row>
</template>

<script>
export default {
  name:'note-view',
  props: {
    image: String,
    time: String,
    text: String,
    right: Boolean,
    contact: String,
  },
  methods: {},
};
</script>

<style  lang="scss">
.container-note {
  border: 2px solid #dedede;
  background-color: #f1f1f1;
  border-radius: 5px;
  padding: 10px;
  width: 70%;
}

.space{
  padding: 10px;
  margin: 10px 0;
}

.darker {
  border-color: #ccc;
  background-color: #ddd;
}

.container-note::after {
  content: "";
  clear: both;
  display: table;
}

.container-note img {
  float: left;
  max-width: 60px;
  width: 100%;
  margin-right: 20px;
  border-radius: 50%;
}

.container-note img.right {
  float: right;
  margin-left: 20px;
  margin-right: 0;
}

.message-info {
  padding-left: 1rem;
}
</style>